import type { FrameStateT } from '../../labelling/types';
import type { UIState } from '../studio-store/types';
import type { AnnotationUIStateRecord } from '../types/annotation';
export function applyAnnotationUIState(annotationUIState: AnnotationUIStateRecord, ids: string[], partial: Partial<UIState>): AnnotationUIStateRecord {
  const updated = new Map(annotationUIState);
  for (const id of ids) {
    const current = updated.get(id) ?? {
      hidden: false,
      locked: false
    };
    updated.set(id, {
      ...current,
      ...partial
    });
  }
  return updated;
}
export function buildMLAnnotationUIStateFromFrames(frames: FrameStateT[]): AnnotationUIStateRecord {
  const uiStateMap = new Map<string, UIState>();
  for (const frame of frames) {
    for (const [annotationId, annotation] of Object.entries(frame.annotationMLStore ?? {})) {
      if (!uiStateMap.has(annotationId)) {
        uiStateMap.set(annotationId, {
          hidden: annotation.hidden ?? false,
          locked: annotation.locked ?? false
        });
      }
    }
  }
  return uiStateMap;
}